import React from 'react';
import {
  IContactInfo,
  IDefaultResponsiveSupport,
  IResumeData,
} from '../../../common/interfaces/common.interface';
import { classnames } from '../../../common/general-utilities/general-utilities';

interface AboutMeProps extends IDefaultResponsiveSupport {
  aboutMe?: IResumeData['aboutMe'];
}
const AboutMe: React.FC<AboutMeProps> = ({ aboutMe }) => {
  return (
    <div style={{padding: '20px'}}>
      <p
        dangerouslySetInnerHTML={{
          __html: aboutMe?.summary
            ?.replace('#YEAR', (new Date().getFullYear() - 2014).toString())
            ?.replace('#SKILL', aboutMe?.skill!) as string,
        }}
      ></p>
      <div style={{ marginTop: '20px' }}>
        {Object.keys(aboutMe?.contactInfo!)?.map((key, i) => {
          return (
            <div
              key={i}
              className={classnames('flex-row')}
              style={{ marginTop: '5px' }}
            >
              <div className={classnames('size-3')}>
                <p>{key}</p>
              </div>
              <div className={classnames('size-9')}>
                <p>{aboutMe?.contactInfo?.[key as keyof IContactInfo]}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AboutMe;
